var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWithdraw(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "withdraw",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M14.162,18.269a1.175,1.175,0,0,0-.837.347L8.587,23.354a1.185,1.185,0,0,0,1.674,1.674l3.9-3.9,3.9,3.9a1.185,1.185,0,0,0,1.674-1.674L15,18.616A1.175,1.175,0,0,0,14.162,18.269Z",
    transform: "translate(1.838 -18.269)",
    fill: "#71207c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M12.435,11.25a1.185,1.185,0,0,0-1.185,1.185V26.649a1.185,1.185,0,0,0,2.369,0V12.435A1.185,1.185,0,0,0,12.435,11.25Z",
    transform: "translate(3.565 -9.671)",
    fill: "#71207c"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M29.157,23.774H5.343a4.141,4.141,0,0,1-2.9-1.17,3.946,3.946,0,0,1-1.2-2.827V5.246a3.946,3.946,0,0,1,1.2-2.827,4.141,4.141,0,0,1,2.9-1.17h9.3v6.9a2.605,2.605,0,0,0,5.209,0V1.25h9.3a4.141,4.141,0,0,1,2.9,1.17,3.946,3.946,0,0,1,1.2,2.827V19.778a3.946,3.946,0,0,1-1.2,2.827A4.141,4.141,0,0,1,29.157,23.774ZM5.343,21.594H29.157a1.839,1.839,0,0,0,1.86-1.816v-3.27H3.483v3.27A1.839,1.839,0,0,0,5.343,21.594ZM9.808,5.609H6.831a1.09,1.09,0,1,0,0,2.18H9.808a1.09,1.09,0,1,0,0-2.18ZM11.3,9.242H6.831a1.09,1.09,0,1,0,0,2.18H11.3a1.09,1.09,0,1,0,0-2.18Z",
    transform: "translate(-1.25 8.226)",
    fill: "#71207c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWithdraw);
export default __webpack_public_path__ + "static/media/icon_withdraw.6e49d93082754cd47420bc927350b171.svg";
export { ForwardRef as ReactComponent };